import React, { useRef, useState } from "react";
import "./styles.scss";

// Renders text on a single line with an ellipsis. On hover it shows a styled
// tooltip (white background, black text) with the full text — but only when the
// text is actually truncated, so short values don't trigger a redundant tooltip.
export const TruncatedCell = ({ text }) => {
  const textRef = useRef(null);
  const [showTip, setShowTip] = useState(false);

  const handleEnter = () => {
    const el = textRef.current;
    // scrollWidth > clientWidth means the text is clipped by the ellipsis.
    if (el && el.scrollWidth > el.clientWidth) {
      setShowTip(true);
    }
  };

  return (
    <div
      className="truncated-cell"
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShowTip(false)}
    >
      <span ref={textRef} className="truncated-cell__text">
        {text}
      </span>
      {showTip && <span className="truncated-cell__tip">{text}</span>}
    </div>
  );
};

export default TruncatedCell;
